export enum PermissionType {
  MANAGE_DIANA = 'MANAGE_DIANA',
  MANAGE_APPOINTMENTS = 'MANAGE_APPOINTMENTS',
  VIEW_APPOINTMENTS = 'VIEW_APPOINTMENTS',
  MANAGE_TENANT = 'MANAGE_TENANT',
  VIEW_TENANT = 'VIEW_TENANT',
  MANAGE_ROLES = 'MANAGE_ROLES',
  VIEW_ROLES = 'VIEW_ROLES',
  MANAGE_USERS = 'MANAGE_USERS',
  VIEW_USERS = 'VIEW_USERS',
  MANAGE_USERPROFILE = 'MANAGE_USERPROFILE',
  VIEW_ORG_UNIT = 'VIEW_ORG_UNIT',
  MANAGE_ORG_UNIT = 'MANAGE_ORG_UNIT',
  VIEW_MEDICAL_HISTORY = 'VIEW_MEDICAL_HISTORY',
  MANAGE_MEDICAL_HISTORY = 'MANAGE_MEDICAL_HISTORY',
  VIEW_CUSTOMER = 'VIEW_CUSTOMER',
  MANAGE_CUSTOMER = 'MANAGE_CUSTOMER',
  MANAGE_SETTING = 'MANAGE_SETTING',
  VIEW_SETTING = 'VIEW_SETTING',
  MANAGE_NEW_CUSTOMER = 'MANAGE_NEW_CUSTOMER',
}